import { selectSize } from '@theme/tsd-table-set-data';

// Hidden pages are unavailable to Liquid. Use the existing snapshot only there.
async function hydrateCampaign(element) {
  const cards = [...element.querySelectorAll('[data-campaign-fallback]')];
  if (!cards.length) return;
  try {
    const response = await fetch(element.dataset.previewSrc, { signal: AbortSignal.timeout(10000) });
    if (!response.ok) return;
    const sets = await response.json();
    if (!Array.isArray(sets) || !element.isConnected) return;
    for (const card of cards) {
      const set = sets.find(set => set.id === card.dataset.campaignSet);
      const size = selectSize(set?.config, 4);
      if (!size) continue;
      const price = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: 'EUR' }).format(size.priceCents / 100);
      const label = document.createElement('span');
      label.textContent = 'für 4 Personen';
      card.querySelector('[data-campaign-price]').replaceChildren(document.createTextNode(`${price} `), label);
    }
  } catch { /* Photos and links remain available if the preview snapshot cannot load. */ }
}
for (const element of document.querySelectorAll('[data-campaign]')) hydrateCampaign(element);
document.addEventListener('shopify:section:load', event => {
  const element = event.target.querySelector('[data-campaign]');
  if (element) hydrateCampaign(element);
});
